<template>
  <div class="product-center-page-container" v-cloak>
    <nav-bar model="blue"></nav-bar>
    <banner></banner>
    <product-content></product-content>
    <customize></customize>
    <page-footer></page-footer>
  </div>
</template>

<script>
import navBar from "../common/navBar";
import banner from "./components/banner";
import productContent from "./components/productContent";
import customize from "../common/customize";
import pageFooter from "../common/pageFooter";
export default {
  components: {
    navBar,
    banner,
    productContent,
    customize,
    pageFooter,
  },
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.product-center-page-container {
}
</style>



// WEBPACK FOOTER //
// src/view/productCenter/productCenter.vue